import type { Entity, ID, Paginator } from 'types';
import { compareIds } from 'util/support';
import type { WritableDraft } from './lib';
import type { ResourceSlice } from './types';

export const deleteTableSliceEntity = <T extends Entity>(
    resourceSlice: WritableDraft<Pick<ResourceSlice<Paginator<T>>, 'tableSlice'>>,
    entityId?: ID | null
) => {
    const { tableSlice } = resourceSlice;

    if (!tableSlice || !entityId) {
        return;
    }

    resourceSlice.tableSlice!.data = tableSlice!.data.filter(({ pki }: Entity) => (
        !compareIds(pki, entityId)
    ));

    resourceSlice.tableSlice!.to -= 1;
    resourceSlice.tableSlice!.total -= 1;
};

export const updateTableSliceEntity = <T extends Entity>(
    resourceSlice: WritableDraft<Pick<ResourceSlice<Paginator<T>>, 'tableSlice'>>,
    entity: Entity
) => {
    const { tableSlice } = resourceSlice;

    if (!tableSlice || !entity) {
        return Array.of<T>();
    }

    return tableSlice.data.map(tableResourceEntity => {
        if (compareIds(
            tableResourceEntity.pki,
            entity.pki
        )) {
            return {
                ...tableResourceEntity,
                ...entity
            };
        }

        return tableResourceEntity;
    }) as T[];
};
